import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "update-hour--sprite",
  "use": "update-hour--sprite-usage",
  "viewBox": "0 0 384.1 384.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384.1 384.1\" id=\"update-hour--sprite\"><polygon points=\"170.8 106.7 170.8 213.4 262.1 267.6 277.4 241.7 202.8 197.4 202.8 106.7 \" /><path d=\"M384.1 0l-58.3 59.9c-74.8-74.1-195.1-74.1-269.9 0 -74.9 74.1-74.3 194.3 0.5 268.5s196.5 74.1 271.4 0c37.5-37.2 56.3-92.1 56.3-134.3h-42.8c0.1 42.2-14.4 75.6-43.4 104.4 -58.2 57.7-152.5 57.7-210.8 0s-58.2-151.1 0-208.9 152.5-55.6 210.8 2.1l-58.6 60.2h144.7V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol